<template>
  <div class="home contenido">
    <div class="container">
    <HeaderSeguros 
        msg="Empresas y corporativos"
        idea="Estamos listos para cubrir cualquier eventualidad, con las mejores opciones para anticipar aquello que pueda amenazar tu inversión."
        clase="empresas-y-corporativos"
     />
     <Titulo titulo="El riesgo es creer que no habrá riesgos" />
     <FotoTexto titulo="Autos / Flotillas" texto="Si tus vehículos se mueven, tu empresa también. Administramos riesgos de flotillas a partir de 200 unidades. Autos y camiones protegidos, con servicios de asistencia, defensa legal, responsabilidad civil y gastos médicos de ocupantes." linkURL="#tresPasos" textoURL="Asegura tu flotilla de autos" :imagen="imagen2" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Empresariales / Naves industriales" texto="Los siniestros son imponderables que pueden traernos pérdidas e inconvenientes. Te ofrecemos seguros con diversas opciones para darle certidumbre a tu proyecto." linkURL="#tresPasos" textoURL="Asegura tu empresa ahora" :imagen="imagen3" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Responsabilidad civil para empresas" texto="Los negocios de hoy requieren implicarse más y mejor con las personas. Contamos con protección frente a reclamaciones por daños a terceros en bienes y personas." linkURL="#tresPasos" textoURL="Asegura tu empresa ahora" :imagen="imagen4" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Daños materiales en empresas" texto="Regresar tu empresa a la normalidad, es vital para la continuidad. El seguro de incendio cubre daños producidos a inmueble, mobiliario, equipo o maquinaria." linkURL="#tresPasos" textoURL="Asegura tu empresa ahora" :imagen="imagen5" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Personal clave" texto="Además de imagen y prestigio, algunas personas contribuyen a las utilidades y crecimiento de la empresa. Protegerlas te da respaldo financiero, libertad económica y beneficios fiscales." linkURL="#tresPasos" textoURL="Asegura tu personal clave ahora" :imagen="imagen6" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Vida grupo (NOM 035)" texto="Un seguro entendido como un respaldo empresarial a empleados, ante las situaciones delicadas que trae la vida, descubre nuestras distintas opciones." linkURL="#tresPasos" textoURL="Asegura a tu equipo de trabajo" :imagen="imagen7" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Transporte de mercancías" texto="El movimiento es una de las claves para mantener a la empresa en un mundo tan conectado. Este seguro ofrece protección, anual o especial a tus bienes en su transportación desde o hasta cualquier parte del planeta." linkURL="#tresPasos" textoURL="Asegura tus mercancías ahora" :imagen="imagen8" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Directivos y consejeros D&O" texto="La prevención de riesgos brinda certeza y asegura el prestigio de las empresas.  Protege a los directivos principales contra acusaciones o reclamación sobre actos ilícitos y demandas presentadas contra la junta directiva y/o oficiales de una organización." linkURL="#tresPasos" textoURL="Asegura a tus directivos y consejeros" :imagen="imagen9" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Equipo contratista y maquinaria pesada con responsabilidad civil" texto="Para las empresas del sector de la construcción protegemos el equipo de contratistas y maquinaria por daños materiales y por los daños que puedan causar a terceros." linkURL="#tresPasos" textoURL="Asegura tu empresa ahora" :imagen="imagen10" pos="fotoderecha"></FotoTexto>
  </div>
  <Trespasoscompleto />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderSeguros from '@/components/HeaderSeguros.vue'
import Imagen from '@/assets/images/banner-header_03-empresas-y-corporativos.png'
import Titulo from '@/components/Titulo.vue'
import FotoTexto from '@/components/FotoTexto.vue'
import Imagen2 from '@/assets/images/pageinteriors_empresas-y-corporativos-01autos-flotillas.jpg'
import Imagen3 from '@/assets/images/pageinteriors_empresas-y-corporativos-02empresariales-naves-industriales.jpg'
import Imagen4 from '@/assets/images/pageinteriors_empresas-y-corporativos-03responsabilidad-civil.jpg'
import Imagen5 from '@/assets/images/pageinteriors_empresas-y-corporativos-04danos-materiales.jpg'
import Imagen6 from '@/assets/images/pageinteriors_empresas-y-corporativos-05persona-clave.jpg'
import Imagen7 from '@/assets/images/pageinteriors_empresas-y-corporativos-06vida-grupo.jpg'
import Imagen8 from '@/assets/images/pageinteriors_empresas-y-corporativos-07transporte-de-mercancias.jpg'
import Imagen9 from '@/assets/images/pageinteriors_empresas-y-corporativos-08directivos-y-consejeros.jpg'
import Imagen10 from '@/assets/images/pageinteriors_empresas-y-corporativos-09Equipo-contratista-y-maquinaria-pesada.jpg'
import Trespasoscompleto from '@/components/Trespasoscompleto.vue'
export default {
  name: 'Empresas-y-corporativos',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
          imagen5: Imagen5,
          imagen6: Imagen6,
          imagen7: Imagen7,
          imagen8: Imagen8,
          imagen9: Imagen9,
          imagen10: Imagen10,
      }
  },
  components: {
    HeaderSeguros,
    Titulo,
    FotoTexto,
    Trespasoscompleto,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
@media only screen and (max-width: 1199px){
}
</style>
